// extracted by mini-css-extract-plugin
module.exports = {"user-feedback":"_1mRY0niqL2ZHBobVTbh6NA"};